import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {handleEvent} from '../../../../events/event-handler';


const getDataFromNode = function(node) {
    const nodeDict = ['id', 'x', 'y', 'src', 'visible', 'alpha', 'bgalpha', 'width', 'zIndex', 'height', 'zIndexOverride'].reduce((data, key) => {
        return { ...data, [key]: node.attr[key] };}, {});
    return nodeDict;
};

class ImageNode extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node),
            hovered: false
        };
        // if a transformer isn't overriding an image_node's zIndex, use the props zIndex by default
        this.state.zIndex = (this.state.zIndex ? this.state.zIndex : props.zIndex);

        this.setVisible = this.setVisible.bind(this);
        this.setInvisible = this.setInvisible.bind(this);
        this.onButtonMouseOver = this.onButtonMouseOver.bind(this);
        this.onButtonMouseOut = this.onButtonMouseOut.bind(this);


    }

    onButtonMouseOver() {
        const event_nodes = this.props.node.childrenNamed('event_node');
        event_nodes.forEach(function (event) {
            if (event.attr.name === 'onmouseover') {
                handleEvent(event);
            }
        });
    }

    onButtonMouseOut() {
        const event_nodes = this.props.node.childrenNamed('event_node');
        event_nodes.forEach(function (event) {
            if (event.attr.title === 'onmouseout') {
                handleEvent(event);
            }
        });
    }

    componentDidMount() {
        if (this.state.id === 'answer') {
            document.addEventListener('jre-answer-visible', this.setVisible);
            document.addEventListener('jre-answer-invisible', this.setInvisible);
        }
        document.addEventListener('jre-image-visible', this.setVisible);
        document.addEventListener('jre-image-invisible', this.setInvisible);
    }

    componentWillUnmount() {
        if (this.state.id === 'answer') {
            document.removeEventListener('jre-answer-visible', this.setVisible);
            document.removeEventListener('jre-answer-invisible', this.setInvisible);
        }
        document.removeEventListener('jre-image-visible', this.setVisible);
        document.removeEventListener('jre-image-invisible', this.setInvisible);
    }

    setInvisible(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({visible: 0});
        }
    }

    setVisible(e) {
        const initialVisibility = parseInt(this.props.node.attr.visible);
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({
                visible: 1,
                /* See the Electricity module, session 5, page 22 (section 522). The image shown after clicking "done"
                is supposed to be above text but only when the initial visibility of the image was hidden. */
                /* changed zIndex from 1 to 4 because it does not impact above name functionality and a higher value
                 is required for image-nodes nested in ce-button-nodes, Fashion & Textiles - 3.1.1 pages 216, 605,
                  704 */
                zIndex: e.type === 'jre-image-visible' && !initialVisibility ? 4 : this.state.zIndex
            });
        }
    }


    render() {
        const {moduleURL = ''} = this.props;
        const {x = 0, y = 0, src = '', visible = 0, alpha = '', bgalpha = '', zIndex = null, width = '', height = '', zIndexOverride} = this.state;
        if (!src) {
            return null;
        }

        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            display: parseInt(visible) ? 'block' : 'none',
        };

        if (zIndex !== null) {
            divStyle.zIndex = zIndex;
        }

        if (zIndexOverride) {
            divStyle.zIndex = zIndexOverride; // Manual override via transform should take priority. MO.LOGR.3.0.0
        }

        // xml files could use either alpha or bgalpha to represent opacity
        if (bgalpha || alpha) {
            if (alpha){
                divStyle.opacity = alpha;
            } else if (bgalpha){ // if we need to set image opacity, we divide the XML value by 100
                divStyle.opacity = (bgalpha === '0' ? 0 : parseInt(bgalpha) / 100);
            }
        }

        const imageStyle = {};
        if (width) {
            // Width may not always be defined, so it isn't added right at style initialization.
            imageStyle.width = `${width}px`;
        }
        if (height) {
            // Height may not always be defined, so it isn't added right at style initialization.
            imageStyle.height = `${height}px`;
        }

        let events = false;
        const event_nodes = this.props.node.childrenNamed('event_node');
        event_nodes.forEach(function (event) {
            if (event.attr.title === 'onmouseout' || event.attr.title === 'onmouseover') {
                events = true;
            }
        });

        return (
            <div className="image-node-container">
                <div className="node" style={divStyle}>
                    {
                        events &&
                        <img
                            onMouseOver={this.onButtonMouseOver.bind(this)}
                            onMouseOut={this.onButtonMouseOut.bind(this)}
                            style={imageStyle} src={`${moduleURL}/media/${src}`} />
                    }
                    {
                        !events &&
                        <img style={imageStyle} src={`${moduleURL}/media/${src}`} />
                    }

                    {/*/!* if the image_node is being used as an overlay, its alpha value will be 0. When visible is false, we stop showing overlay *!/*/}
                    {/*{ parseInt(alpha) === 0 && parseInt(visible) ?*/}
                    {/*<div className="overlay-mask"/> :*/}
                    {/*<div className="node" style={divStyle}>*/}
                    {/*<img style={imageStyle} src={`${moduleURL}/media/${src}`}/>*/}
                    {/*</div>*/}
                    {/*}*/}
                </div>
            </div>
        );
    }
}

ImageNode.propTypes = {
    node: PropTypes.object.isRequired,
    zIndex: PropTypes.number
};

export default withRouter(ImageNode);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/image-node.js